import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AdminLayoutComponent, BlankLayoutComponent, MapaCoreModule} from '@mapa/core';
import {RestringirAcessoGuard} from './shared/core/guards/restringir-acesso.guard';
import {EnsureUserLoadedGuard} from './shared/service/ensure-user-loaded-guard.service';

const routes: Routes = [
    {
        path: '',
        component: AdminLayoutComponent,
        // canActivate: [EnsureUserLoadedGuard, RestringirAcessoGuard],
        canActivateChild: [EnsureUserLoadedGuard, RestringirAcessoGuard],
        children: [
            {
                path: '',
                loadChildren: './feature/home/home.module#HomeModule'
            }
        ]
    },
    {
        path: 'operacao',
        component: BlankLayoutComponent,
        // canActivate: [EnsureUserLoadedGuard, RestringirAcessoGuard],
        canActivateChild: [EnsureUserLoadedGuard, RestringirAcessoGuard],
        children: [
            {
                path: '',
                loadChildren: './feature/operacao/operacao.module#OperacaoModule'
            }
        ]
    },
    {
        path: 'gestao-acesso',
        component: BlankLayoutComponent,
        // canActivate: [EnsureUserLoadedGuard, RestringirAcessoGuard],
        canActivateChild: [EnsureUserLoadedGuard, RestringirAcessoGuard],
        children: [
            {
                path: '',
                loadChildren: './feature/gestao-acesso/gestao-acesso.module#GestaoAcessoModule'
            }
        ]
    },
    {
        path: 'consulta-publica',
        component: BlankLayoutComponent,
        // canActivate: [EnsureUserLoadedGuard, RestringirAcessoGuard],
        canActivateChild: [EnsureUserLoadedGuard, RestringirAcessoGuard],
        children: [
            {
                path: '',
                loadChildren: './feature/consulta-publica/consulta-publica.module#ConsultaPublicaModule'
            }
        ]
    },

];

@NgModule({
    imports: [
        MapaCoreModule,
        RouterModule.forRoot(routes, {
            useHash: true,
            enableTracing: false
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}



